import ThemeCvDto from "../models/cvTheme"
import GeneralService from "./generalService"

class CvThemeService extends GeneralService<ThemeCvDto> {
	constructor() {
		super("theme_cv")
	}

	getAllCvThemes(): Promise<ThemeCvDto[]> {
		return this.getAllWithFilters()
	}
}

const cvThemeService = new CvThemeService()
export default cvThemeService
